module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'figure-buttons/base' && templateVars.config ?
				templateVars.config :
				{
	"createTooltips": true,
	"theme": [
		"default",
		"tooltipster-tooltips"
	],
	"side": "left"
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/figure-buttons/.variant/base/config.yaml
// module id = 182
// module chunks = 0